import { TradePriceInfo } from '@/types'
import { useExistingTrade } from 'hooks/useExistingTrade'
import useTranslation from 'next-translate/useTranslation'
import dynamic from 'next/dynamic'
import { Suspense } from 'react'
import { Artist, Edition, mapTradeToTradePrices } from 'utils/data'

const ExistingTradeInfo = dynamic(
  () =>
    import('components/artwork/ExistingTradeInfo').then(
      m => m.ExistingTradeInfo
    ),
  { ssr: false }
)

type Props = {
  currentEdition?: Edition | null
  artists: Artist[]
  name: string
  id: number
}

export function ExistingTrades({ currentEdition, artists, name, id }: Props) {
  const { t } = useTranslation()

  const existingTradePayload = {
    currentEdition,
    artists: artists,
    name: name,
    id,
  }

  const { existingTrade: existingAsk, editUrl: editAskUrl } = useExistingTrade({
    ...existingTradePayload,
    tradeType: 'ask',
  })
  const { existingTrade: existingBid, editUrl: editBidUrl } = useExistingTrade({
    ...existingTradePayload,
    tradeType: 'bid',
  })

  return (
    <>
      {existingAsk?.price ? (
        <Suspense>
          <ExistingTradeInfo
            text={t('single_artwork:you_have_a_live_listing')}
            editUrl={editAskUrl}
            tradePrices={mapTradeToTradePrices(existingAsk) as TradePriceInfo}
          />
        </Suspense>
      ) : null}

      {existingBid?.price ? (
        <Suspense>
          <ExistingTradeInfo
            text={t('single_artwork:you_have_a_live_offer')}
            editUrl={editBidUrl}
            tradePrices={mapTradeToTradePrices(existingBid) as TradePriceInfo}
          />
        </Suspense>
      ) : null}
    </>
  )
}
